import { makeStyles } from '@material-ui/core/styles';
import { btMediumGrayColor, btNavyBlueColor } from '../../assets/jss/nextjs-material-kit-pro';

export const useScholarshipApplicationListStyles = makeStyles((theme) => ({
  frame: {
    width: '100vw',
  },
  alignPage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  formatTableSize: {
    margin: '0 auto 0 auto',
    maxWidth: '1320px',
  },
  noLeftPadding: {
    paddingLeft: '0 !important',
  },
  sortHeader: {
    cursor: 'pointer',
    color: btNavyBlueColor,
    border: 'none',
  },
  nosortHeader: {
    color: btMediumGrayColor,
  },
  tableRow: {
    height: '45px',
  },
  approvalLink: {
    fontSize: '0.70rem',
    height: '28px',
    padding: '10px 5px 5px 5px',
    textTransform: 'none',
    justifyContent: 'center',
    margin: '31px 10px 0 0',
  },
  idNoLink: {
    padding: 0,
  },
  gridLink: {
    color: btNavyBlueColor,
    fontSize: '0.75rem',
    padding: 0,
    '&:hover': {
      cursor: 'pointer',
    },
    textTransform: 'none',
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
  },
  centerAlignContent: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '10px',
  },
  filter: {
    margin: '5px 0 15px 20px',
  },
  switchLeadingText: {
    margin: '5px 20px 15px 0',
  },
  noSeniorsMsg: {
    fontSize: '1.15rem',
    margin: 5,
  },
  whiteBg: {
    background: '#FFFFFF',
  },
  centerRadioSorting: {
    marginLeft: 20,
    marginRight: 20,
    justifyContent: 'space-between',
  },
  radioLabel: {
    fontSize: '0.85rem',
    fontWeight: 500,
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  radioRow: {
    width: '100%',
    justifyContent: 'space-between',
  },
  selectDropdown: {
    color: '#333',
    backgroundColor: '#fff',
  },
  menuItem: {
    '&:hover': {
      color: '#fff',
      backgroundColor: '#8c857b',
    },
  },
  cardContainer: {
    padding: '30px 20px',
  },
  card: {
    color: '#000',
    backgroundColor: '#fff',
    margin: '0 10px',
    height: '100px',
  },
  completedCardContent: {
    padding: '5px 10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  awardedCardContent: {
    padding: '5px 10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  completed: {
    paddingTop: 5,
    fontSize: '1.00rem',
    lineHeight: '1.425rem',
    fontWeight: 500,
  },
  totalSummary: {
    color: btNavyBlueColor,
    fontSize: '.90rem',
    lineHeight: '1.425rem',
  },
  awardAmount: {
    color: btNavyBlueColor,
    fontSize: '1.75rem',
    lineHeight: '2.2rem',
  },
  headerSelect: {
    width: '160px',
  },
  dataExplanation: {
    marginTop: '10px',
    fontSize: '.85rem',
    color: btNavyBlueColor,
  },
}));

export default useScholarshipApplicationListStyles;
